import React from "react";
import Grid from "@material-ui/core/Grid";
import MaterialTable from "material-table";
import { stElemnt } from "../../../../St/Reviews/cStyle";
import { colors } from "@material-ui/core";
import InvTotal from "../../AFReadyDisigen/A4/InvTotal";
import { useRptAF } from "../../../../St/Reviews/UseStyle";
import { getcolor } from "../../invCompany/A4/UnderHeader";
import "../invoiceprint.css"
import { cellSName, styleNo, styleOthers } from "../../ShareFunctionsPrint";

const BodyInv = (props) => {
  const cls = useRptAF();
  const { data, isLast, inv, sta, premiApp ,locInv} = props;


  const st_name = {
    width: "32%",
    padding: "0px 0px",
    textAlign: "-webkit-center",
    margin: "0px",
    fontSize: "16px",
    border: "solid 0.1px",
    whiteSpace: "normal",
    wordBreak: "break-word",
    lineHeight: 1.5,
    overflowWrap: "anywhere",
  }
  const showBar = premiApp.billTemplate === 12 || premiApp.billTemplate === 6 || premiApp.billTemplate === 16 || premiApp.billTemplate === 19;
  var columns = [
    { title: "No \n م", field: "no", cellStyle: styleNo ,className:"invoice-rows"},
    { title: "Barcode \n الباركود", field: "barcode", hidden: showBar ? true : false },
    { title: "Item Name \n اسم الصنف", field: "symbol", cellStyle: st_name ,
      render:rowData=>( <span className="invoice-rows">  {rowData.symbol} </span>)
    },
    { title: "Unit \n الوحدة", field: "unit_name", hidden: showBar ? false : true },
    { title: "Quantity \n الكمية ", field: "val1", },
    { title: "Price \n سعر الوحدة", field: "new_exchange_price", },
    { title: sta?.tot?.re_disc ?"Retention \n خصم ضمان": "Discount \n الخصم", field: "discount", },
    { title: "BeforeVat \n  الخاضع للضريبة", field: "totBill", },
    { title: "VatAmount \n مبلغ الضريبة", field: "taxval", },
    { title: "NetAmount \n شامل الضريبة", field: "tot_net_curr", },
  ];
  var columns31 = [
    { title: "No \n م", field: "no", cellStyle: styleNo },
    { title: "Barcode \n الباركود", field: "barcode", hidden: premiApp.billTemplate === 31 ? true : false },
    // { title: "Item Name \n اسم الصنف", field: "symbol", cellStyle: premiApp.billTemplate === 1 ? st_name : cellSName },
    { title: "Item Name \n اسم الصنف", field: "symbol", cellStyle: premiApp.billTemplate === 31 ?{...cellSName,fontSize:"16px"}: st_name ,
    render:rowData=>( <span className="invoice-rows">  {rowData.symbol} </span>) },
    { title: "Unit \n الوحدة", field: "unit_name", },
    { title: "Quantity \n الكمية ", field: "val1" },
    { title: "Price \n السعر ", field: "new_exchange_price", },
    { title:  sta?.tot?.re_disc ?"Retention \n خصم ضمان":"Discount \n الخصم", field: "discount" },
    { title: "BeforeVat \n  الخاضع للضريبة", field: "totBill" },
    { title: "VatAmount \n مبلغ الضريبة", field: "taxval" },
    { title: "NetAmount \n شامل الضريبة", field: "tot_net_curr" },
  ];

  var columns12 = [
    { title: "Description \n الوصف", field: "notes_details", cellStyle: cellSName,
      render:rowData=>( <span className="invoice-rows">  {rowData.notes_details} </span>) 
    },
    { title: "Unit \n الوحدة", field: "unit_name", },
    { title: "Quantity \n الكمية ", field: "val1" },
    { title: "Price \n سعر الوحدة", field: "new_exchange_price", },
    { title: sta?.tot?.re_disc ?"Retention \n خصم ضمان": "Discount \n الخصم", field: "discount" },
    { title: "BeforeVat \n  الخاضع للضريبة", field: "totBill" },
    { title: "VatAmount \n مبلغ الضريبة", field: "taxval" },
    { title: "NetAmount \n شامل الضريبة", field: "tot_net_curr" },
  ];
  var columns15 = [
    { title: "No \n م", field: "no" },
    { title: "Description \n الوصف", field: "notes_detailsItems", cellStyle: cellSName,
      render:rowData=>( <span className="invoice-rows">  {rowData.notes_detailsItems} </span>) 
     },
    { title: "Quantity \n الكمية ", field: "val1" },
    { title: "Price \n سعر الوحدة", field: "new_exchange_price", },
    { title: "BeforeVat \n  الخاضع للضريبة", field: "totBill" },
    { title: "VatAmount \n مبلغ الضريبة", field: "taxval" },
    { title: "NetAmount \n شامل الضريبة", field: "tot_net_curr" },
  ];

  const cellSD4 = {
    textAlign: "-webkit-center",
    margin: "0px",
    border: "solid 0.1px",
    fontSize: "0.75rem",
    width: "33%",
    fontFamily: "Amiri-Regular",
    fontWeight: "bold",
    whiteSpace: 'pre-wrap',
    overflowWrap: 'break-word',
    direction: "rtl",
    textAlign: "right",
    paddingRight: "5px",
    paddingTop: "0px",
    paddingBottom: "0px"
  };
  var columns17 = [
    { title: "No \n م", field: "no", cellStyle: styleNo },
    { title: "Barcode \n الباركود", field: "barcode",  },
    { title: "Description \n الوصف", field: "notesall", cellStyle: cellSD4,
      render:rowData=>( <span className="invoice-rows">  {rowData.notesall} </span>)
    },
    { title: "Qoantity \n الكمية ", field: "val1" },
    { title: "Price \n سعر الوحدة", field: "new_exchange_price", },
    { title: "BeforeVat \n  الخاضع للضريبة", field: "totBill" },
    { title: "VatAmount \n مبلغ الضريبة", field: "taxval" },
    { title: "NetAmount \n شامل الضريبة", field: "tot_net_curr" },
  ];
  var columnsCar = [
    { title: "No \n م", field: "no", cellStyle: styleNo },
    { title: "Service \n الخدمة", field: "symbol", cellStyle: cellSName,
      render:rowData=>( <span className="invoice-rows">  {rowData.symbol} </span>)  },
    { title: "Unit Name \n الوحدة", field: "unit_name" },
    { title: "Quantity \n الكمية ", field: "val1" },
    { title: "Service Price \n سعر الخدمة", field: "new_exchange_price", },
    { title: "BeforeVat \n  الخاضع للضريبة", field: "totBill" },
    { title: "VatAmount \n مبلغ الضريبة", field: "taxval" },
    { title: "NetAmount \n شامل الضريبة", field: "tot_net_curr" },
  ];

  var columnsIshar = [
    { title: "Item Name \n اسم الصنف", field: "symbol", cellStyle: st_name,
      render:rowData=>( <span className="invoice-rows">  {rowData.symbol} </span>)
    },
    { title: "Quantity \n الكمية ", field: "val1" },
    { title: "Price \n السعر ", field: "new_exchange_price", },
    { title: "New Price \n السعر بعد الاشعار ", field: "Ishar_NewPrice",cellStyle:styleOthers  },
    { title: "Notifaction Price \n مبلغ الاشعار ", field: "Ishar_amout_sub",cellStyle:styleOthers  },
    { title: "Notifaction Tot \n اجمالي الاشعار ", field: "Ishar_amout_tot",cellStyle:styleOthers  },
    { title: "VAT Total \n After Notifaction \n الضريبة بعد الاشعار ", field: "NewTax_AfterIshar",cellStyle:styleOthers  },
    { title: "Total After \n Notifaction \n الصافي بعد الاشعار ", field: "NewTot_AfterIshar",cellStyle:styleOthers  },
    { title: "Notifaction \n Vat Amount \n ضريبة الاشعار", field: "Ishar_tax_sub",cellStyle:styleOthers  },
    { title: "Notifaction \n net Amount \n  صافي الاشعار", field: "Ishar_amout_net_sub",cellStyle:styleOthers },
  ];

  const invColors = sta?.StngIA?.colors;
  const secondColor = getcolor(invColors);
  return (
    <Grid item container className={cls.rootBdy}>
      <Grid item container //className={cls.rootBdyup}
        style={{
          paddingTop: "0.5rem", direction: "rtl", border: "dotted 1px #393939",
        }}>
        <Grid
          container
          item
          xs={12}
        >
          <MaterialTable
            style={{ boxShadow: "none", tableLayout: "fixed", width: "100%" }}
            options={{
              showTitle: false,
              toolbar: false,
              sorting: false,
              selection: false,
              // ToolBar Search
              searchFieldAlignment: "left",
              searchFieldVariant: "outlined",
              // ToolBar header
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              pageSize: 5,
              paginationType: "stepped",
              showFirstLastPageButtons: false,
              headerStyle: {
                ...stElemnt.AF.header,
                backgroundColor: premiApp.billTemplate === 17 || premiApp.billTemplate === 20 ? secondColor : colors.grey[100],
                fontWeight: "bold",
                paddingTop: "2px",
                paddingBottom: "2px",
                border: "solid 0px",
                border: "solid 0.1px",
              },
              paging: false,
              cellStyle: {
                ...stElemnt.AF.cell,
                padding: "0px 1px",
              },
            }}
            localization={{ body: { emptyDataSourceMessage: <h1></h1> } }}
            columns={["150", "149"].includes(inv.ProcType_InvProc) ? (columnsIshar.map(column => ({
              ...column,
              title: column.title.split("\n").map((line, index) => (
                <div key={index}>{line}</div>
              )),

            }))) : premiApp.billTemplate === 12 ? (columns12.map(column => ({
              ...column,
              title: column.title.split("\n").map((line, index) => (
                <div key={index}>{line}</div>
              )),

            }))) : premiApp.billTemplate === 15 ? (columns15.map(column => ({
              ...column,
              title: column.title.split("\n").map((line, index) => (
                <div key={index}>{line}</div>
              )),

            }))) : premiApp.billTemplate === 17 ? (columns17.map(column => ({
              ...column,
              title: column.title.split("\n").map((line, index) => (
                <div key={index}>{line}</div>
              )),

            }))) : premiApp.billTemplate === 31 ? (columns31.map(column => ({
              ...column,
              title: column.title.split("\n").map((line, index) => (
                <div key={index}>{line}</div>
              )),

            }))) : premiApp.billTemplate === 14 ? (columnsCar.map(column => ({
              ...column,
              title: column.title.split("\n").map((line, index) => (
                <div key={index}>{line}</div>
              )),

            }))) :
              (columns.map(column => ({
                ...column,
                title: column.title.split("\n").map((line, index) => (
                  <div key={index}>{line}</div>
                )),

              })))}
            data={data}
          />
          {isLast && <InvTotal inv={inv} sta={sta} premiApp={premiApp}  locInv={locInv}/>}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default BodyInv;
